import { ResultContent } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import { ModalComponentWrapper } from '@/shared/components';
import { useModalStore } from '@/shared/lib';

const useCancelOperationResult = () => {
  const { showDialogComponent, closeDialog } = useModalStore();
  const { t } = useTranslation();

  const goToSuccessScreen = () => {
    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess
            onClick={closeDialog}
            title={t('historyPage.cancelOperation.result.success.title')}
            description={t(
              'historyPage.cancelOperation.result.success.description'
            )}
            buttonText={t(
              'historyPage.cancelOperation.result.success.buttonText'
            )}
            buttonVariant="secondary"
            className="h-auto"
          />
        </ModalComponentWrapper>
      ),
    });
  };

  const goToErrorScreen = () => {
    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess={false}
            onClick={closeDialog}
            title={t('historyPage.cancelOperation.result.error.title')}
            description={t(
              'historyPage.cancelOperation.result.error.description'
            )}
            buttonVariant="secondary"
            buttonText={t(
              'historyPage.cancelOperation.result.error.buttonText'
            )}
            className="h-auto"
          />
        </ModalComponentWrapper>
      ),
    });
  };

  return {
    goToSuccessScreen,
    goToErrorScreen,
  };
};

export { useCancelOperationResult };
